module.exports = __webpack_public_path__ + "static/media/image.97c1e653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/PrivacyPolicy/image.jpg
// module id = 395
// module chunks = 0